import Vue from 'vue';
import uuid from 'uuid';

export default Vue.directive('spinner', {
    update: function (el, binding) {
        const spinner = document.getElementById(el.uuid);
        toggleSpinner(el.children[0], spinner, binding.value);
    },

    bind: function (el, binding) {
        let wrapper = document.createElement('div');
        el.style.display = 'flex';
        el.style.justifyContent = 'center';
        el.style.alignItems = 'center';
        wrapper.innerHTML = el.innerHTML;
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
        el.appendChild(wrapper);
        let spinner = document.createElement('div');
        const _uuid = uuid();
        spinner.id = _uuid;
        el.uuid = _uuid;
        spinner.innerHTML = svg;
        spinner.left = 0;
        spinner.top = 0;
        wrapper.style.display = !binding.value ? 'block' : 'none';
        spinner.style.display = binding.value ? 'block' : 'none';
        toggleSpinner(wrapper, spinner, binding.value);
        el.appendChild(spinner);
    }
});

function toggleSpinner(el, spinner, value) {
    if (value === undefined) value = true;
    el.style.display = !value ? 'block' : 'none';
    spinner.style.display = value ? 'block' : 'none';
}

const svg = `
            <svg class="spinner" width="28px" height="28px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="static" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
                </circle>
                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
                </circle>
            </svg>
        `;



// WEBPACK FOOTER //
// ./src/directives/SpinnerDirective.js